import { Box, HStack, VStack, Text } from "@chakra-ui/react";

interface StatCardProps {
  icon: React.ElementType;
  value: number;
  label: string;
  colorScheme: string;
}

const StatCard = ({ icon: Icon, value, label, colorScheme }: StatCardProps) => (
  <Box bg={`${colorScheme}.500`} color="white" p={4} borderRadius="lg" boxShadow="md">
    <HStack spacing={4} align="center">
      <Box
        bg="whiteAlpha.300"
        p={3}
        borderRadius="md"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Icon size={24} />
      </Box>
      <VStack align="start" spacing={0}>
        <Text fontSize="2xl" fontWeight="bold">
          {value.toLocaleString("it-IT")}
        </Text>
        <Text fontSize="sm" opacity={0.9}>
          {label}
        </Text>
      </VStack>
    </HStack>
  </Box>
);

export default StatCard;
